import { makeAutoObservable } from 'mobx';
import { PasswordDetailInterface } from '../../interfaces/AuthInterface';
import { DefaultPasswordDetail } from '../common';
import {
  InvoicingDetailsInterface,
  ProfileDataInterface,
  SettingIntegrationInterface,
  SubscriptionDataInterface,
  TeamcampAIDataInterface,
  NotificationSettingDetailsInterface
} from '../../interfaces/SettingsInterface';

export class SettingStore {
  passwordDetail: PasswordDetailInterface = DefaultPasswordDetail;
  invoicingDetail: InvoicingDetailsInterface | null = null;
  invoiceSetting: InvoicingDetailsInterface | null = null;
  profileData: ProfileDataInterface | null = null;
  settingIntegration: SettingIntegrationInterface | null = null;
  teamcampAIData: TeamcampAIDataInterface[] = [];
  loading: boolean = false;
  subscriptionList: SubscriptionDataInterface | null = null;
  notificationSettingDetails: NotificationSettingDetailsInterface = {
    Browser: false,
    Email: false,
    Mobile: false,
    updated: false
  };
  // teacampAiDetail:an

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  // Update specific password field
  updatePasswordDetail(propsName: string, value: string) {
    this.passwordDetail = {
      ...this.passwordDetail,
      [propsName]: value
    };
  }

  // Clear password detail
  clearPasswordDetail() {
    this.passwordDetail = DefaultPasswordDetail;
  }

  setLoading(value: boolean) {
    this.loading = value;
  }

  setInvoicingDetail(invoicingDetail: InvoicingDetailsInterface) {
    this.invoicingDetail = invoicingDetail;
  }

  // Update invoice details
  updateInvoicingDetail(propsName: string, value: string | number | { name: string; value: string }[]) {
    if (this.invoicingDetail) {
      this.invoicingDetail = {
        ...this.invoicingDetail,
        [propsName]: value
      };
    }
  }

  //Set user profile data
  setProfileData(profileData: ProfileDataInterface) {
    this.profileData = profileData;
  }

  setSettingIntegration(settingIntegration: SettingIntegrationInterface) {
    this.settingIntegration = settingIntegration;
  }

  // Update invoice details
  updateProfileData(propsName: string, value: string | number | { name: string; value: string }[]) {
    if (this.profileData) {
      this.profileData = {
        ...this.profileData,
        [propsName]: value
      };
    }
  }

  // Set Teamcamp AI data
  setTeamcampAIData(data: TeamcampAIDataInterface[]) {
    this.teamcampAIData = data;
  }

  setSubscriptionList(data: SubscriptionDataInterface) {
    this.subscriptionList = data;
  }

  // Invoice setting setters
  setInvoiceSetting(data: InvoicingDetailsInterface) {
    this.invoiceSetting = data;
  }

  updateInvoiceSetting(
    propsName: keyof InvoicingDetailsInterface,
    value: InvoicingDetailsInterface[keyof InvoicingDetailsInterface]
  ) {
    if (this.invoiceSetting) {
      this.invoiceSetting = {
        ...this.invoiceSetting,
        [propsName]: value
      };
    }
  }

  clearInvoiceSetting() {
    this.invoiceSetting = null;
  }

  setNotificationSettingDetails(data: NotificationSettingDetailsInterface): void {
    this.notificationSettingDetails = data;
  }

  setNotificationProperty(propertyName: 'Browser' | 'Email' | 'Mobile' | 'updated', value: boolean): void {
    let updatedValue = true;
    if (propertyName === 'updated') {
      updatedValue = value;
    }
    this.notificationSettingDetails = {
      ...this.notificationSettingDetails,
      [propertyName]: value,
      updated: updatedValue
    };
  }

  clearNotificationSettingDetails(): void {
    this.notificationSettingDetails = {
      Browser: false,
      Email: false,
      Mobile: false,
      updated: false
    };
  }

  // Clear password related data
  clearSettingData() {
    this.loading = false;
    this.passwordDetail = DefaultPasswordDetail;
    this.invoicingDetail = null;
    this.settingIntegration = null;
    this.subscriptionList = null;
    this.invoiceSetting = null;
    this.teamcampAIData = [];
  }
}
